// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3NRia","header":"MessagesList_header__2UQh4","chat":"MessagesList_chat__3ICK_"};